// GES-126: a loss event (mortality, stocktake count-down) is recordable up to PHYSICAL stock; this returns how far
// committed-undelivered sales would be short AFTER the loss (0 = no warning). Non-blocking, display only.
export function lossShortfall(physical, committed, qty) {
  const p = Number(physical), c = Number(committed), q = Number(qty);
  if (!(c > 0) || !(q > 0) || Number.isNaN(p)) return 0;
  return Math.max(0, Math.round((c - (p - q)) * 1e4) / 1e4);
}
